import React from 'react';
import { X, List } from '@phosphor-icons/react';
interface DesignHeaderProps {
  onNavigate: (page: string) => void;
  onOpenMobileMenu: () => void;
  closeTarget?: string;
}
export function DesignHeader({
  onNavigate,
  onOpenMobileMenu,
  closeTarget = 'home'
}: DesignHeaderProps) {
  return <div className="h-[80px] flex items-center justify-end px-8 flex-shrink-0 sticky top-0 z-10 bg-white" data-id="element-116">
      <button onClick={() => onNavigate(closeTarget)} className="p-2 rounded-full hover:bg-[#111111] text-black hover:text-white transition-all duration-300 transform hover:scale-105 hidden md:block" aria-label="Close design view" data-id="element-117">
        <X size={30} data-id="element-118" />
      </button>
      <button onClick={onOpenMobileMenu} className="p-2 rounded-full hover:bg-[#111111] text-black hover:text-white transition-all duration-300 transform hover:scale-105 md:hidden" aria-label="Open menu" data-id="element-119">
        <List size={30} data-id="element-120" />
      </button>
    </div>;
}